var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFilingDrafts(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.7425 11.9656L18.0972 11L19.7425 10.0344C20.5097 9.58644 20.9817 8.76369 20.9817 7.875C20.9817 6.98631 20.5097 6.16357 19.7425 5.71557L12.2489 1.34057C11.4708 0.886477 10.5097 0.886477 9.73277 1.34057L2.23919 5.71557C1.47203 6.16357 1 6.98631 1 7.875C1 8.76369 1.472 9.58644 2.23919 10.0344L3.9028 11L2.25749 11.9656C1.49033 12.4136 1.0183 13.2363 1.0183 14.125C1.0183 15.0137 1.4903 15.8364 2.25749 16.2844L9.75107 20.6594C10.5292 21.1135 11.4903 21.1135 12.2672 20.6594L19.7608 16.2844C20.528 15.8364 21 15.0137 21 14.125C21 13.2363 20.528 12.4136 19.7608 11.9656H19.7425ZM11 3.49994L18.4936 7.87494L11 12.2499L3.50642 7.87494L11 3.49994ZM11 18.4999L3.50642 14.1249L6.37871 12.4465L9.75113 14.4093C10.5293 14.8634 11.4904 14.8634 12.2673 14.4093L15.6213 12.4465L18.4936 14.1249L11 18.4999Z",
    fill: "#596780"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFilingDrafts);
export default __webpack_public_path__ + "static/media/filing-drafts.fac7ef6e5734612fb0560bd51d987e0f.svg";
export { ForwardRef as ReactComponent };